import {
    Dialog, DialogTitle, DialogContent, DialogActions, Button,
    Table, TableHead, TableRow, TableCell, TableBody, Typography, Box,
} from '@mui/material';
import { formatPrice } from '../utils/format';
import { b2bColors } from '../styles/b2bTheme';

/**
 * Shown after a 409 PRICE_DRIFT from POST /orders. Lists the drifted
 * lines with old/new/delta. Confirming updates the cart snapshots so
 * the next submit uses the fresh prices.
 */
export default function PriceDriftDialog({ open, driftedLines = [], onConfirm, onCancel }) {
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            maxWidth="sm"
            fullWidth
            aria-labelledby="price-drift-title"
        >
            <DialogTitle id="price-drift-title">Certains prix ont changé</DialogTitle>
            <DialogContent>
                <Typography variant="body2" sx={{ mb: 2 }}>
                    Les prix suivants ont été mis à jour depuis que vous les avez ajoutés au panier.
                    Confirmez pour continuer avec les nouveaux prix, ou annulez pour réviser votre panier.
                </Typography>
                <Box sx={{ border: `1px solid ${b2bColors.border}`, borderRadius: 0.5 }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Produit</TableCell>
                                <TableCell align="right" className="b2b-num">Ancien</TableCell>
                                <TableCell align="right" className="b2b-num">Nouveau</TableCell>
                                <TableCell align="right" className="b2b-num">Écart</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {driftedLines.map((line) => (
                                <TableRow key={line.product_id}>
                                    <TableCell>
                                        <Typography variant="body2" sx={{ fontWeight: 500 }}>{line.name || line.sku}</Typography>
                                        <Typography variant="body2" sx={{ fontSize: 11, color: b2bColors.textMuted }}>{line.sku}</Typography>
                                    </TableCell>
                                    <TableCell align="right" className="b2b-num">{formatPrice(line.old_price)}</TableCell>
                                    <TableCell align="right" className="b2b-num" sx={{ fontWeight: 600 }}>{formatPrice(line.new_price)}</TableCell>
                                    <TableCell
                                        align="right"
                                        className="b2b-num"
                                        sx={{ color: Number(line.delta) > 0 ? b2bColors.danger : b2bColors.success, fontWeight: 600 }}
                                    >
                                        {Number(line.delta) > 0 ? '+' : ''}{formatPrice(line.delta)}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel}>Annuler</Button>
                <Button onClick={onConfirm} variant="contained">
                    Confirmer les nouveaux prix
                </Button>
            </DialogActions>
        </Dialog>
    );
}
